import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-500 text-sm md:text-base">深度策划 · 完整还原 · 一文看懂</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item, i) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div className="relative aspect-[16/9] md:aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 五一黑料网焦点专题`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold mb-2">
                    {item.subtitle}
                  </span>
                  <h3 className="font-heading font-bold text-lg md:text-xl text-background-50 mb-2">{item.title}</h3>
                  <p className="text-background-100/80 text-sm leading-relaxed line-clamp-2">{item.excerpt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}